import React, { FC } from 'react';
import { TSpecCell } from '../../../types/index.types';

const SpecCell: FC<TSpecCell> = (props) => {
  const { specIndex, subArr, subObj, accIndex, showHiddenRightCells, hide, fadeIn, colOrdInIndex } = props;
  if (!showHiddenRightCells && specIndex > 5) return null;

  return (
    <td
      className={`
        model-detail-specification-table__table-cell
        model-detail-specification-table__table-cell--${specIndex % 2 === 0 ? 'even' : 'odd'}
        ${hide || subArr.length === accIndex + 1 ? 'model-detail-specification-table__table-cell--border-hidden' : ''}
      `}
    >
      <div
        key={`model-detail-specification-table__spec-row-child-${specIndex}`}
        className={`
          model-detail-specification-table__spec
          model-detail-specification-table__cell-animation
          ${fadeIn ? 'model-detail-specification-table__cell-animation--show-animation' : ''}
          ${hide ? 'model-detail-specification-table__cell-animation--hide' : ''}
        `}
      >
        {subObj.specs?.[colOrdInIndex[specIndex]]?.value}
      </div>
    </td>
  );
};

export default React.memo(SpecCell);
